import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import {FullPatient, IPspCompanyDTO, PatientAddress, PatientUpdated} from 'src/app/_models/patient.model';
import { AreaService } from 'src/app/_services/area.service';
import { CityService } from 'src/app/_services/city.service';
import { PatientService } from 'src/app/_services/patient.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { City } from 'src/app/_models/city.model';
import { Area } from 'src/app/_models/area.model';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { NationalIdValidator } from 'src/app/shared/nationalId-validator';
import { NameValidator } from 'src/app/shared/name-validator';
import { showNotification } from 'src/app/helpers/show-toast';
import { ToastrService } from 'ngx-toastr';
import { PatientScreenTypeEnum } from 'src/app/enums/patient-screen-enum';

@Component({
  selector: 'app-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.scss'],
})
export class PatientDetailsComponent implements OnInit, OnDestroy {
  pageId = 1;
  viewInit = false;
  patient = {} as FullPatient;
  nationalIdAndPassportId: string = '';
  notificationModal: BsModalRef;
  newAddress = {} as PatientAddress;
  cityList: City[];
  areaList: Area[];
  patientId: number;
  moreMenuItems = {};
  editMode = false;
  readOnly = false;
  returnToSub = false;
  addressIdToBeDeleted: number;
  addAddressForm = {
    keyboard: true,
    class: 'modal-dialog-centered modal-black',
  };
  editPatientProfileForm:FormGroup;
  patientScreenType: PatientScreenTypeEnum;
  patientScreenTypesEnum = PatientScreenTypeEnum;
  constructor(
    private patientService: PatientService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private cityService: CityService,
    private areaService: AreaService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    public toastr: ToastrService,
  ) {}

  ngOnDestroy(): void {
    this.patientService.isMedicalTests.next(false);
    this.patientService.isPspSection.next(false);
    localStorage.removeItem('screenType');
  }

  ngOnInit(): void {
    this.patientService.isMedicalTests.subscribe((flag) => {
      this.pageId = flag ? 3 : 1;
    });

    this.patientService.isPspSection.subscribe((flag) => {
      this.pageId = flag ? 2 : 1;
    });

    let screenTypeFromLocalStorage = JSON.parse(localStorage.getItem('screenType'));
    if(screenTypeFromLocalStorage){
      this.patientScreenType = screenTypeFromLocalStorage
      localStorage.removeItem('screenType');
    }
    else
      this.patientService.getPatientScreenType().subscribe(type => this.patientScreenType = type);

    const id = this.activatedRoute.snapshot.params.patientId;
    if (id) {
      this.patientId = id;
      if(this.patientScreenType == PatientScreenTypeEnum.LimitlesscarePatients || PatientScreenTypeEnum.LcaPatients)
        this.patientService.getPateintById(id).subscribe((res) => {
          this.getPatientSubscriptionDetails(res);
        });
      else
        this.patientService.getPspPatientDetails(id).subscribe((res) => {
          this.getPatientSubscriptionDetails(res);
        });
    }
  }

  getPatientSubscriptionDetails(res){
    this.patient = res.data;
    this.patientService.patient = res.data;
    this.nationalIdAndPassportId = `${this.patient.personalInfo.nationalId ?? ''} ${(this.patient.personalInfo.nationalId && this.patient.personalInfo.passportId) ? '/' : ''} ${this.patient.personalInfo.passportId ?? ''}`;
    this.patient.personalInfo.pspCompany = this.getPatientPspCodes(this.patient.personalInfo.pspCompany);
    for (let index = 0; index < this.patient.addresses.length; index++) {
      this.moreMenuItems[index] = false;
    }

    if (this.patient.personalInfo.areaId) {
      this.areaService
        .getStringAreaName(this.patient.personalInfo.areaId)
        .subscribe((res) => {
          this.patient.personalInfo.areaName = res.data.enName;
        });
    }
    this.cityService.getAllCities().subscribe((res) => {
      this.cityList = res;
      if (this.patient.personalInfo.cityId) {
        this.patient.personalInfo.cityName = this.cityList.find(
          (city) => city.id === this.patient.personalInfo.cityId
        )?.enName;
      }
      this.patient.addresses.map((address) => {
        address.cityName = this.cityList.find(
          (city) => city.id === address.cityId
        )?.enName;
        this.areaService
          .getStringAreaName(address.areaId)
          .subscribe((res) => {
            address.areaName = res.data.enName;
            this.spinner.hide();
          });
      });
    });
    this.spinner.hide();
  }

  onAddNewTest(event) {
    event.stopPropagation();

    this.router.navigate(['patient-details', this.patientId, 'add-new-test']);
  }

  openNotificationModal(
  modalNotification: TemplateRef<any>,
  editMode = false,
  address = null,
  viewOnly = false,
  returnToSub = false
): void {
  this.spinner.show();

  // Reset newAddress if it's not in editMode
  if (!editMode) {
    this.newAddress = {} as PatientAddress; // Clear any existing data
  }

  // If in editMode, populate the newAddress with the provided address and fetch areas
  if (editMode && address) {
    this.onCityChange(address.cityId, false, address); // Update city and area
  }

  // Open the modal
  this.notificationModal = this.modalService.show(modalNotification, this.addAddressForm);

  // Reset newAddress when modal is hidden
  this.notificationModal.onHide?.subscribe(() => {
    this.resetNewAddress(); // Reset newAddress on modal hide
  });

  this.spinner.hide(); // Hide spinner once modal is shown

  // Set modal-related flags
  this.readOnly = viewOnly;
  this.editMode = editMode;
  this.returnToSub = returnToSub;
}

resetNewAddress(): void {
  this.newAddress = {} as PatientAddress; // Reset to an empty object
}


  nationalIdAndPassportIdValidator(control: AbstractControl): ValidationErrors | null {
    let nationalIdControl = control.get('nationalId');
    let passportIdControl = control.get('passportId');
    let isNationalIdInvalid = NationalIdValidator();
    let nationalIdElement = document.getElementById('nationalId');
    let passportIdElement = document.getElementById('passportId');

    if (!isNationalIdInvalid(nationalIdControl) || (passportIdControl.value && !nationalIdControl.value)) {
      if(nationalIdElement){
        nationalIdElement.classList.add('ng-valid');
        nationalIdElement.classList.remove('invalid');
      }
      if(passportIdElement){
        passportIdElement.classList.add('ng-valid');
        passportIdElement.classList.remove('invalid');
      }
      return null;
    }

    if(nationalIdElement)
    {
      nationalIdElement.classList.remove('ng-valid');
      nationalIdElement.classList.add('invalid');
    }
    if(passportIdElement){
      passportIdElement.classList.remove('ng-valid');
      passportIdElement.classList.add('invalid');
    }

    return { nationalIdAndPassportIdError: {
      nationalIdError : isNationalIdInvalid(nationalIdControl),
      passportIdError: !passportIdControl
    }};
  }

  openEditPatientNotificationModal(modalNotification: TemplateRef<any>): void {
    this.spinner.show();
    this.editPatientProfileForm = this.formBuilder.group({
      fullName: [this.patient.personalInfo.fullName, [Validators.required, NameValidator()]],
      nationalId: [this.patient.personalInfo.nationalId, this.patient.personalInfo.nationalId ? NationalIdValidator() : []],
      passportId: [this.patient.personalInfo.passportId, this.patient.personalInfo.passportId ? Validators.required : []],
      isPassportId: [this.patient.personalInfo.passportId ? true : false],
      birthDate: [this.datePipe.transform(this.patient.personalInfo.birthdate, "yyyy-MM-dd"), [Validators.required]],
      cityId: [this.patient.personalInfo.cityId, [Validators.required]],
      areaId: [this.patient.personalInfo.areaId, [Validators.required]]
    },
    {
      validator: this.nationalIdAndPassportIdValidator
    });

    if(this.patient.personalInfo.areaId){
      this.areaService.getAreasByCityId(this.patient.personalInfo.cityId).subscribe((res) => {
        this.areaList = res?.data?.areas;
        this.notificationModal = this.modalService.show(modalNotification)
        this.spinner.hide();
        if(!this.patient.personalInfo.nationalId && !this.patient.personalInfo.passportId)
        {
          let nationalIdElement = document.getElementById('nationalId');
          let passportIdElement = document.getElementById('passportId');
          if(nationalIdElement){
            nationalIdElement.classList.remove('ng-valid');
            nationalIdElement.classList.add('ng-invalid');
          }
          if(passportIdElement){
            passportIdElement.classList.remove('ng-valid');
            passportIdElement.classList.add('ng-invalid');
          }
        }
      });
    }
    else{
      this.notificationModal = this.modalService.show(
        modalNotification
        )
      this.spinner.hide();
      if(!this.patient.personalInfo.nationalId && !this.patient.personalInfo.passportId)
      {
        let nationalIdElement = document.getElementById('nationalId');
        let passportIdElement = document.getElementById('passportId');
        if(nationalIdElement){
          nationalIdElement.classList.remove('ng-valid');
          nationalIdElement.classList.add('ng-invalid');
        }
        if(passportIdElement){
          passportIdElement.classList.remove('ng-valid');
          passportIdElement.classList.add('ng-invalid');
        }
      }
    }
  }

  onCityChange(cityId, flag = true, address = null) {
    if (cityId) {
      this.spinner.show();

      this.areaService.getAreasByCityId(cityId).subscribe((res) => {
        this.areaList = res?.data?.areas;
        if(this.editPatientProfileForm)
          this.editPatientProfileForm.patchValue({areaId: null});
        if (flag) {
          this.newAddress.areaId = null;
        } else {
          this.newAddress = { ...address };
        }
        this.newAddress.cityId = cityId;
        this.newAddress.cityName = this.cityList.find(
          (city) => city.id === +cityId
        )?.enName;
        this.spinner.hide();
      });
    }
  }
onAreaChange(areaId) {
  if (areaId) {
    this.spinner.show();
    this.newAddress.areaId = areaId;
    this.newAddress.areaName = this.areaList.find((area) => area.id === +areaId)?.enName;

    // Update only the form control 'areaId' in the editPatientProfileForm
    if (this.editPatientProfileForm) {
      this.editPatientProfileForm.patchValue({ areaId: areaId });
    }

    this.spinner.hide();
  }
}


  onSubmit(form: NgForm): void {
    this.spinner.show();
    const body = { patientId: this.patientId, ...this.newAddress };

    if (!this.editMode) {
      this.patientService.addAddress(body).subscribe((res) => {
        if (res) {
          let addedAddress = { ...res.data } as PatientAddress;
          addedAddress.cityName = this.cityList.find(
            (city) => city.id === res.data.cityId
          )?.enName;
          addedAddress.areaName = this.areaList.find(
            (area) => area.id === res.data.areaId
          )?.enName;
          this.patient.addresses.push(addedAddress);

          this.notificationModal.hide();
          this.spinner.hide();
        }
      });
    } else {
      this.patientService.updateAddress(body).subscribe((res) => {
        if (res) {
          const oldAddressIndex = this.patient.addresses.findIndex(
            (ad) => this.newAddress.patientAddressId == ad.patientAddressId
          );

          if (oldAddressIndex != -1) {
            this.patient.addresses[oldAddressIndex] = { ...body };
          }

          this.notificationModal.hide();
          this.spinner.hide();
        }
      });
    }
  }

  openNDeleteModal(modalNotification: TemplateRef<any>, addressId): void {
    this.spinner.show();
    this.notificationModal = this.modalService.show(
      modalNotification,
      this.addAddressForm
    );
    this.addressIdToBeDeleted = addressId;
    this.spinner.hide();
  }
  onDeleteAddress() {
    this.spinner.show();

    const id = this.addressIdToBeDeleted;
    this.patientService.deleteAddress(id).subscribe((res) => {
      if (res) {
        this.patient.addresses = [
          ...this.patient.addresses.filter(
            (address) => address.patientAddressId !== id
          ),
        ];
        this.notificationModal.hide();
        this.spinner.hide();
      }
    });
  }

  openMenuItem(index) {
    Object.keys(this.moreMenuItems).forEach((item) => {
      this.moreMenuItems[item] =
        item == index ? !this.moreMenuItems[index] : false;
    });
    // this.moreMenuItems[key][index] = !this.moreMenuItems[key][index];
  }

  onSubmitEditPatient(){
    const patientData: PatientUpdated = {
      patientId: +this.patientId,
      fullName: this.editPatientProfileForm.controls.fullName.value,
      birthdate: this.editPatientProfileForm.controls.birthDate.value,
      nationalId: this.editPatientProfileForm.controls.nationalId.value,
      passportId: this.editPatientProfileForm.controls.passportId.value,
      cityId: +this.editPatientProfileForm.controls.cityId.value,
      areaId: +this.editPatientProfileForm.controls.areaId.value,
    };
    this.notificationModal.hide();
    if(this.editPatientProfileForm.dirty){
      this.patientService.updatePatientDetails(patientData).subscribe(
        (response) => {
          if (response.data.flag) {
            showNotification(
              'success',
              `Data updated successfully`,
              this.toastr
            );
            window.location.reload();
          }
        }
      );
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onbeforeunload(event) {
    localStorage.setItem('screenType', JSON.stringify(this.patientScreenType));
  }

  private getPatientPspCodes(pspCompany: IPspCompanyDTO[]): IPspCompanyDTO[] {
    const objectIdentifier = ({companyName, pspCode}) => `${companyName}-${pspCode}`;

    const ids = pspCompany.map(objectIdentifier);

    return pspCompany.filter((item, index) => !ids.includes(objectIdentifier(item), index + 1));
  }
}
